import {BorcluVekiliEntity} from "@/entity/BorcluVekiliEntity";

export default class TerekeData {
    borcluAdi: string = "";
    isTereke: boolean = false;
    uniqueDataText: string = "";
    uniqueData: string = "";
    adres: string="";
    vekiller: Array<BorcluVekiliEntity> =[];
}